import $ from 'jquery';
import $script from 'scriptjs';

export default class TemplateGiftCard {
  constructor() {
    const scripts = $('[data-scripts]');
    $script([scripts.data('qrcode-js-url')], () => {
      this.addQrCode();
    });
  }

  addQrCode() {
    const qrWrapper = $('[data-qr-code]');

    this.qrCode = new QRCode(qrWrapper[0], {
      text: qrWrapper.data('qr-code'),
      width: 120,
      height: 120,
    });
  }
}
